var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-detailed"},[_c('div',{staticClass:"title-detailed-button",on:{"click":function($event){return _vm.$emit('close')}}},[_c('i',{staticClass:"el-icon-back"}),_vm._v(" "+_vm._s(_vm.backName)+" ")]),_c('span',{staticClass:"detailed"},[_vm._v(_vm._s(_vm.title)),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }